var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:_vm.iconClass,style:(_vm.iconStyle),attrs:{"color":_vm.iconColor,"size":_vm.iconSize}},[_vm._v(" "+_vm._s(_vm.portalIcon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }